import {Injectable} from '@angular/core';
import {List} from "../pages/list/list";
import {CustomDetail} from "../pages/custom/customdetail/customdetail";
import {IFrame} from "../pages/iframe/iframe";
import {LiniendiagrammPage} from "../pages/liniendiagramm/liniendiagramm";
import {Detail} from "../pages/detail/detail";
import {Table} from "../pages/table/table";
import {GridBoxPage} from "../pages/grid-box/grid-box";
import {HomePage} from "../pages/home/home";
import {PdfViewerPage} from "../pages/pdf-viewer/pdf-viewer";
import {ScannerPage} from "../pages/scanner/scanner";
import {Signature} from "../pages/signature/signature";
import {LoginPage} from "../pages/login/login";
import {EbsWebService} from "./ebsWebService";

@Injectable()
export class EbsComponentService {
  constructor( public  _ebsWebService: EbsWebService ) {}

  getComponentByAction(action) {
    switch (action) {
      case "Table":
        return Table;
      case "List":
        return List;
      case "Detail":
        return Detail;
      case "LinienDiagramm":
        return LiniendiagrammPage;
      case "IFrame":
        return IFrame;
      case "ChartTypePie":
        return CustomDetail;
      case "GridBox":
        return GridBoxPage;
      case "File_PDF":
        return PdfViewerPage;
      case "BarCodeScanner":
        return ScannerPage;
      case "Signature":
        return Signature;
      case "LoginPage":
        return LoginPage;
      default:
        return HomePage;
    }
  }

  navigationController(element,navparams,navCtrl,component=null) {
    if (component == null){
      component = this.getComponentByAction(element.ViewTypeAction);
    }
    switch (element.ActionType) {
      case "Pop":
        let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(element.PostParameters);
        this._ebsWebService.postData(element.Action, postPayloadObject).toPromise().then(res=>{
          navCtrl.pop();
        }).catch(error => {
          console.error(error);
        });
        break;
      case "SetRoot":
        navCtrl.setRoot(component, navparams);
        break;
      default:
        navCtrl.push(component, navparams);
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/services/ebsComponentService.ts